import React, { useState, useEffect, useRef } from 'react';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalBody,
   ModalCloseButton,
   Button,
   Box,
   Flex,
   Text,
   VStack,
   Badge,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   Center,
   useDisclosure,
   useColorModeValue,
   HStack,
   Icon,
   IconButton,
   Tooltip,
} from '@chakra-ui/react';
import { BsBank2 } from 'react-icons/bs';
import { RiMoneyDollarCircleLine } from 'react-icons/ri';
import {
   FaUser,
   FaUniversity,
   FaStickyNote,
   FaCalendarAlt,
   FaFileInvoiceDollar,
   FaMoneyCheckAlt,
   FaHashtag,
   FaPrint,
   FaInfoCircle,
   FaEllipsisV,
   FaEdit,
   FaTrashAlt,
   FaReceipt,
   FaMoneyBillWave,
} from 'react-icons/fa';
import dotIcon from '../../assets/img/nfts/dot.svg';
import { MdDeleteOutline, MdOutlineEdit, MdDescription } from 'react-icons/md';
import AddEditForm from '../../views/admin/masters/Pages/CustomerMaster/AddEditForm';
import ItemMasterForm from '../../views/admin/masters/Pages/ItemMaster/ItemMasterForm';
import AddEditFormForAccount from '../../views/admin/masters/Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../../views/admin/masters/Pages/DaybookMaster/DaybookForm';
import DeleteDialog from '../../views/admin/masters/components/DeleteDialog';
import { deleteVendor } from '../../redux/actions/vendor';
import { deleteCustomer } from '../../redux/actions/account';
import { deleteItem } from '../../redux/actions/item';
import { deleteDaybook } from '../../redux/actions/daybook';
import { useDispatch } from 'react-redux';
import { useUser } from 'contexts';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { deleteVoucher } from '../../redux/actions/voucher';
import about from 'assets/img/nfts/about.svg';
import printIcon from 'assets/img/nfts/print.svg';
import SalesDetails from 'components/salesDetails/SalesDetails';
import { getSetupFormat } from '../../redux/actions/setupFormat';
import LogView from 'components/salesDetails/LogView';
import moment from 'moment';

const ViewSingleCashBankData = ({
   isOpenSingleView,
   onClose,
   entityType,
   singleEntity,
   isBankPageTrue,
   formType,
   parentGlGroup,
   UserRights,
   startEditing,
   receiveRight,
   paymentRight,
   onLogClick,
}) => {
   const [selectedRowId, setSelectedRowId] = useState(null);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
   const dispatch = useDispatch();
   const { user } = useUser();
   const Admin = user?.userType?.includes(6);
   const { isOpen: isShowLog, onOpen: onShowLog, onClose: onCloseLog } = useDisclosure();
   const [logId, setLogId] = useState(null);
   const [isOpen, setIsOpen] = useState(false);
   const [isEditMode, setIsEditMode] = useState(false);
   const [shouldOpenModalForWpSettings, setShouldOpenModalForWpSettings] = useState(false);

   const bgGradient = useColorModeValue('linear(to-br, blue.50, purple.50)', 'gray.800');
   const cardBg = useColorModeValue('white', 'gray.700');
   const borderColor = useColorModeValue('gray.200', 'gray.600');
   const accentColor = singleEntity?.txnType === 0 ? 'green' : 'orange';
   const shadowColor = useColorModeValue('lg', 'dark-lg');
   const labelColor = useColorModeValue('gray.600', 'gray.400');
   const valueColor = useColorModeValue('gray.800', 'white');
   const iconBg = useColorModeValue(`${accentColor}.50`, `${accentColor}.900`);
   const iconColor = useColorModeValue(`${accentColor}.600`, `${accentColor}.200`);
   const mainbg = useColorModeValue('gray.50', 'gray.700');
   const headerBg = useColorModeValue('gray.50', 'gray.700');
   const hoverBg = useColorModeValue('gray.100', 'gray.600');
   const businessType = localStorage.getItem('businessTypes');
   const mobile = businessType === 'MOBILE';

   const renderInfoTab = () => (
      <Box bgGradient={bgGradient} borderRadius="xl" p={4} position="relative" overflow="hidden">
         {/* Decorative gradient overlay */}
         <Box
            position="absolute"
            top="-50%"
            right="-10%"
            width="300px"
            height="300px"
            borderRadius="full"
            bgGradient={`radial(${accentColor}.100, transparent)`}
            opacity={0.3}
            pointerEvents="none"
         />

         <Flex
            direction={{ base: 'column', md: 'row' }}
            align="center"
            gap={{ base: 6, md: 8 }}
            position="relative"
            zIndex={1}>
            {/* FROM Section */}
            <VStack align="stretch" spacing={3} flex="1">
               <Box
                  bg={cardBg}
                  borderRadius="lg"
                  p={3}
                  px={5}
                  shadow={shadowColor}
                  border="1px solid"
                  borderColor={borderColor}
                  transition="all 0.3s"
                  _hover={{
                     transform: 'translateY(-2px)',
                     shadow: 'xl',
                     borderColor: `${accentColor}.300`,
                  }}>
                  <HStack spacing={3} mb={3}>
                     <Flex bg={iconBg} p={2} borderRadius="lg" align="center" justify="center">
                        <Icon as={FaUser} color={iconColor} boxSize={5} />
                     </Flex>
                     <Text
                        color={labelColor}
                        fontSize="sm"
                        fontWeight="semibold"
                        textTransform="uppercase"
                        letterSpacing="wide">
                        From
                     </Text>
                  </HStack>
                  <Text fontWeight="bold" fontSize="lg" color={valueColor} pl={1}>
                     {singleEntity?.txnType === 0 ? singleEntity?.accountName : singleEntity?.daybookName}
                  </Text>
               </Box>
            </VStack>

            {/* Arrow Icon with animation */}
            <Flex
               align="center"
               justify="center"
               bg={cardBg}
               borderRadius="full"
               p={3}
               shadow="md"
               border="2px solid"
               borderColor={`${accentColor}.300`}>
               <Icon as={ArrowForwardIcon} boxSize={6} color={`${accentColor}.600`} />
            </Flex>

            {/* TO Section */}
            <VStack align="stretch" spacing={3} flex="1">
               <Box
                  bg={cardBg}
                  borderRadius="lg"
                  p={3}
                  px={5}
                  shadow={shadowColor}
                  border="1px solid"
                  borderColor={borderColor}
                  transition="all 0.3s"
                  _hover={{
                     transform: 'translateY(-2px)',
                     shadow: 'xl',
                     borderColor: `${accentColor}.300`,
                  }}>
                  <HStack spacing={3} mb={3}>
                     <Flex bg={iconBg} p={2} borderRadius="lg" align="center" justify="center">
                        <Icon as={FaUniversity} color={iconColor} boxSize={5} />
                     </Flex>
                     <Text
                        color={labelColor}
                        fontSize="sm"
                        fontWeight="semibold"
                        textTransform="uppercase"
                        letterSpacing="wide">
                        To
                     </Text>
                  </HStack>
                  <Text fontWeight="bold" fontSize="lg" color={valueColor} pl={1}>
                     {singleEntity?.txnType === 1 ? singleEntity?.accountName : singleEntity?.daybookName}
                  </Text>
               </Box>
            </VStack>
         </Flex>
      </Box>
   );

   const renderOtherInfoTab = () => (
      <Box mt={6}>
         <Box
            bg={cardBg}
            borderRadius="lg"
            p={5}
            shadow={shadowColor}
            border="1px solid"
            borderColor={borderColor}
            transition="all 0.3s"
            _hover={{
               borderColor: 'blue.300',
               shadow: 'xl',
            }}>
            <HStack spacing={3} mb={3}>
               <Flex bg="blue.50" p={2} borderRadius="lg" align="center" justify="center">
                  <Icon as={FaStickyNote} color="blue.600" boxSize={5} />
               </Flex>
               <Text
                  color={labelColor}
                  fontSize="sm"
                  fontWeight="semibold"
                  textTransform="uppercase"
                  letterSpacing="wide">
                  Note
               </Text>
            </HStack>
            <Text fontWeight="medium" fontSize="md" color={valueColor} pl={1} lineHeight="tall">
               {singleEntity?.userNote || '-'}
            </Text>
         </Box>
      </Box>
   );

   const renderPaymentTab = () => (
      <Box mt={4}>
         <HStack spacing={3} mb={4}>
            <Flex bg="purple.50" p={2} borderRadius="lg" align="center" justify="center">
               <Icon as={FaFileInvoiceDollar} color="purple.600" boxSize={5} />
            </Flex>
            <Text fontSize="lg" fontWeight="bold" color={valueColor}>
               Transaction Details
            </Text>
         </HStack>

         <Box
            bg={cardBg}
            borderRadius="lg"
            overflow="hidden"
            shadow={shadowColor}
            border="1px solid"
            borderColor={borderColor}>
            <Table variant="simple" size="md">
               <Thead bg={mainbg}>
                  <Tr>
                     <Th>
                        <HStack spacing={2}>
                           <Icon as={FaCalendarAlt} boxSize={3} />
                           <Text>Date</Text>
                        </HStack>
                     </Th>
                     <Th>
                        <HStack spacing={2}>
                           <Icon as={MdDescription} boxSize={4} />
                           <Text>Description</Text>
                        </HStack>
                     </Th>
                     {singleEntity?.chequeDate && (
                        <Th>
                           <HStack spacing={2}>
                              <Icon as={FaCalendarAlt} boxSize={3} />
                              <Text>Cheque Date</Text>
                           </HStack>
                        </Th>
                     )}
                     {singleEntity?.chequeNo && (
                        <Th>
                           <HStack spacing={2}>
                              <Icon as={FaHashtag} boxSize={3} />
                              <Text>Cheque No</Text>
                           </HStack>
                        </Th>
                     )}
                     <Th isNumeric>
                        <HStack spacing={2} justify="flex-end">
                           <Icon as={FaMoneyCheckAlt} boxSize={4} />
                           <Text>Amount</Text>
                        </HStack>
                     </Th>
                  </Tr>
               </Thead>
               <Tbody>
                  {singleEntity?.outAdjustments?.length > 0 ? (
                     singleEntity.outAdjustments.map((payment, index) => (
                        <Tr key={index} _hover={{ bg: mainbg }} transition="all 0.2s">
                           <Td fontWeight="medium">
                              {payment?.transactionAt
                                 ? new Date(payment.transactionAt).toLocaleDateString('en-GB').replace(/\//g, '-')
                                 : ''}
                           </Td>
                           <Td>
                              <HStack>
                                 <Badge
                                    colorScheme={singleEntity?.txnType === 0 ? 'green' : 'orange'}
                                    fontSize="xs"
                                    px={2}
                                    py={1}
                                    borderRadius="md">
                                    {singleEntity?.txnType === 0 ? 'Sale' : 'Purchase'}
                                 </Badge>
                                 <Text fontWeight="medium">#{payment?.docno}</Text>
                              </HStack>
                           </Td>
                           {singleEntity?.chequeDate && (
                              <Td fontWeight="medium">
                                 {singleEntity?.chequeDate
                                    ? new Date(singleEntity?.chequeDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                                    : ''}
                              </Td>
                           )}
                           {singleEntity?.chequeNo && <Td fontWeight="medium">{singleEntity?.chequeNo}</Td>}
                           <Td isNumeric>
                              <Text fontWeight="bold" fontSize="md" color={`${accentColor}.600`}>
                                 ₹ {payment?.amount.toFixed(2)}
                              </Text>
                           </Td>
                        </Tr>
                     ))
                  ) : (
                     <Tr>
                        <Td colSpan={5} textAlign="center" py={8} color={labelColor} fontStyle="italic">
                           No {singleEntity?.txnType === 0 ? 'receivable' : 'payment'} information available
                        </Td>
                     </Tr>
                  )}
               </Tbody>
            </Table>
         </Box>
      </Box>
   );

   const handleEditClick = () => {
      setIsEditMode(true);
      setIsOpen(true);
      if (startEditing) {
         startEditing(singleEntity);
      }
      onClose();
   };

   const handleClose = () => {
      setIsOpen(false);
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            if (formType === 'Vendor') {
               await dispatch(deleteVendor(selectedRowId));
            } else if (formType === 'Customer') {
               await dispatch(deleteCustomer(selectedRowId));
            } else if (formType === 'Item') {
               await dispatch(deleteItem(selectedRowId));
            } else if (formType === 'daybook') {
               await dispatch(deleteDaybook(selectedRowId));
            } else if (formType === 'Account') {
               await dispatch(deleteVoucher(selectedRowId));
            } else if (formType === 'voucher') {
               await dispatch(deleteVoucher(selectedRowId));
            }
            setDeleteDialogOpen(false);
            onClose(true);
         } catch (err) {
            console.error('Failed to delete series:', err);
         }
      }
   };

   const handleLogShow = () => {
      setLogId(singleEntity?.id);
      onShowLog();
   };

   // Check edit rights based on txnType
   const hasEditRights = () => {
      if (Admin) return true;

      if (singleEntity?.txnType === 0) {
         return receiveRight?.edit;
      } else if (singleEntity?.txnType === 1) {
         return paymentRight?.edit;
      }

      return UserRights?.edit;
   };

   // Check delete rights based on txnType
   const hasDeleteRights = () => {
      if (Admin) return true;

      if (singleEntity?.txnType === 0) {
         return receiveRight?.deleteRole;
      } else if (singleEntity?.txnType === 1) {
         return paymentRight?.deleteRole;
      }

      return UserRights?.deleteRole;
   };

   // Check if user has any rights (edit or delete)
   const hasAnyRights = () => {
      return hasEditRights() || hasDeleteRights();
   };

   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === 'Escape') {
            if (!isShowLog && !shouldOpenModalForWpSettings) {
               onClose();
            }
            if (shouldOpenModalForWpSettings) {
               setShouldOpenModalForWpSettings(false);
            }
         }
      };

      window.addEventListener('keydown', handleKeyDown, true);
      return () => {
         window.removeEventListener('keydown', handleKeyDown, true);
      };
   }, [onClose, isShowLog, shouldOpenModalForWpSettings]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 'p' && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();

            const performAction = async () => {
               if (isOpenSingleView && !shouldOpenModalForWpSettings) {
                  const resp = await dispatch(
                     getSetupFormat({
                        companyId: user?.loginhistory?.companyId,
                        daybookId: singleEntity?.daybookId,
                        functionName:
                           singleEntity?.txnType === 0
                              ? isBankPageTrue
                                 ? 'Bank Receipt'
                                 : 'Cash Receipts'
                              : isBankPageTrue
                                 ? 'Bank Payment'
                                 : 'Cash Payments',
                     }),
                  );
                  setShouldOpenModalForWpSettings(true);
               }
            };

            performAction();
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [
      dispatch,
      isBankPageTrue,
      isOpen,
      isOpenSingleView,
      shouldOpenModalForWpSettings,
      singleEntity?.daybookId,
      singleEntity?.txnType,
      user?.loginhistory?.companyId,
   ]);

   return (
      <>
         <Modal isOpen={isOpenSingleView} onClose={onClose} size="3xl">
            <ModalOverlay />
            <ModalContent borderRadius="md" mx="15px">
               <ModalHeader>
                  <Box>
                     {/* Top Section with Title and Actions */}
                     <Flex direction="row" justifyContent="space-between" alignItems="center" gap={3} mb={4}>
                        <HStack spacing={3}>
                           <Flex bg={iconBg} p={2.5} borderRadius="lg" align="center" justify="center">
                              <Icon as={isBankPageTrue ? BsBank2 : FaMoneyBillWave} color={iconColor} boxSize={5} />
                           </Flex>
                           <Box>
                              <Text fontSize="xl" fontWeight="bold" color={valueColor}>
                                 {isBankPageTrue ? 'Bank' : 'Cash'}{' '}
                                 {singleEntity?.txnType === 0 ? 'Receive' : 'Payment'}
                              </Text>
                              <Text fontSize="sm" color={labelColor} fontWeight="medium">
                                 Document #{singleEntity?.docNumber}
                              </Text>
                           </Box>
                        </HStack>
                        <ModalCloseButton w={5} h={6} size={''} />

                        <Flex>
                           <Box
                              cursor="pointer"
                              onClick={handleLogShow}
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              title="About">
                              <img src={about} alt="Edit" width={23} />
                           </Box>
                           <Box
                              cursor="pointer"
                              _hover={{ bg: 'gray.200', variant: 'ghost', borderRadius: '50px' }}
                              p="10px"
                              title="Print"
                              onClick={async () => {
                                 const resp = await dispatch(
                                    getSetupFormat({
                                       companyId: user?.loginhistory?.companyId,
                                       daybookId: singleEntity?.daybookId,
                                       functionName:
                                          singleEntity?.txnType === 0
                                             ? isBankPageTrue
                                                ? 'Bank Receipt'
                                                : 'Cash Receipts'
                                             : isBankPageTrue
                                                ? 'Bank Payment'
                                                : 'Cash Payments',
                                    }),
                                 );
                                 setShouldOpenModalForWpSettings(true);
                              }}>
                              <img src={printIcon} alt="Print" width={23} />
                           </Box>
                           {hasAnyRights() && user && (!user.isExpired) && (isBankPageTrue ? user?.packageData?.[0]?.bank : user?.packageData?.[0]?.cash) && (
                              <Menu>
                                 <MenuButton
                                    as={Box}
                                    cursor="pointer"
                                    _hover={{
                                       bg: 'gray.200',
                                       variant: 'ghost',
                                       borderRadius: '50px',
                                    }}
                                    p="10px"
                                    title="menu">
                                    <img src={dotIcon} alt="Menu" width={23} />
                                 </MenuButton>
                                 <MenuList p={3}>
                                    {hasEditRights() && (
                                       <MenuItem onClick={handleEditClick} fontSize={'md'} fontWeight={'bold'} gap={3}>
                                          <MdOutlineEdit size={20} /> Edit
                                       </MenuItem>
                                    )}
                                    {hasDeleteRights() && (
                                       <MenuItem
                                          onClick={() => handleDeleteClick(singleEntity?.id)}
                                          fontSize={'md'}
                                          fontWeight={'bold'}
                                          textColor={'red.600'}
                                          gap={3}>
                                          <MdDeleteOutline size={20} /> Delete
                                       </MenuItem>
                                    )}
                                 </MenuList>
                              </Menu>
                           )}
                        </Flex>
                     </Flex>

                     {/* Date and Amount Section */}
                     <Flex
                        direction={{ base: 'column', md: 'row' }}
                        justifyContent="space-between"
                        alignItems={{ base: 'flex-start', md: 'center' }}
                        gap={4}
                        bg={headerBg}
                        p={3}
                        borderRadius="lg">
                        <HStack spacing={3}>
                           <Flex bg="blue.50" p={2} borderRadius="md" align="center" justify="center">
                              <Icon as={FaCalendarAlt} color="blue.600" boxSize={4} />
                           </Flex>
                           <Box>
                              <Text fontSize="xs" color={labelColor} fontWeight="medium" mb={0.5}>
                                 Transaction Date
                              </Text>
                              <Text fontSize="lg" fontWeight="bold" color={valueColor}>
                                 {singleEntity?.txnDate
                                    ? new Date(singleEntity.txnDate).toLocaleDateString('en-GB').replace(/\//g, '-')
                                    : ''}
                              </Text>
                           </Box>
                        </HStack>

                        <HStack spacing={3}>
                           <Box textAlign={{ base: 'left', md: 'right' }}>
                              <HStack spacing={2} justify={{ base: 'flex-start', md: 'flex-end' }}>
                                 <Text fontSize="2xl" fontWeight="bold" color={valueColor}>
                                    ₹ {singleEntity?.amount?.toLocaleString('en-IN')}
                                 </Text>
                                 <Badge
                                    colorScheme={singleEntity?.txnType === 0 ? 'green' : 'orange'}
                                    fontSize="sm"
                                    px={3}
                                    py={1}
                                    borderRadius="full"
                                    fontWeight="bold">
                                    {singleEntity?.txnType === 0 ? 'Received' : 'Paid'}
                                 </Badge>
                              </HStack>
                           </Box>
                        </HStack>
                     </Flex>
                  </Box>
               </ModalHeader>
               <ModalBody px={{ base: 3, xl: 6 }} py={0}>
                  {/* Content area with border */}
                  <Box border="1px solid #ccc" borderRadius="10px" p={{ base: 3, xl: 5 }}>
                     {renderInfoTab()}
                     {mobile && renderPaymentTab()}
                     {singleEntity?.userNote && renderOtherInfoTab()}
                  </Box>
                  {/* Created At - Always show if data exists */}
                  {singleEntity?.createdAt && singleEntity?.createdu && (
                     <Flex justify="flex-end">
                        <Text color="gray.500" fontSize="sm" mt={3}>
                           Created on {moment(singleEntity.createdAt).format('DD/MM/YYYY hh:mm:ss A')} By{' '}
                           {singleEntity.createdu}
                        </Text>
                     </Flex>
                  )}

                  {/* Updated At - Only show if data exists */}
                  {singleEntity?.updatedAt && singleEntity?.updatedu && (
                     <Flex justify="flex-end">
                        <Text color="gray.500" fontSize="sm" mt={3}>
                           Updated on {moment(singleEntity.updatedAt).format('DD/MM/YYYY hh:mm:ss A')} By{' '}
                           {singleEntity.updatedu}
                        </Text>
                     </Flex>
                  )}
                  <LogView isOpen={isShowLog} onClose={onCloseLog} title="Log" entityType="voucher" id={logId} />
               </ModalBody>

               {/* Footer with buttons */}
               <Flex justify="end" gap={3} mr={{ base: 0, xl: 3 }} px={4} py={4} mt={{ base: 0, xl: 2 }}></Flex>
               {singleEntity && shouldOpenModalForWpSettings && (
                  <SalesDetails
                     salesData={singleEntity}
                     setShouldOpenModalForCashBank={setShouldOpenModalForWpSettings}
                     shouldOpenModalForCashBank={shouldOpenModalForWpSettings}
                     cashbankid={singleEntity?.id}
                  />
               )}
            </ModalContent>
         </Modal>

         {(formType === 'Customer' || formType === 'Vendor') && (
            <AddEditForm
               isOpen={isOpen}
               onClose={handleClose}
               isEditMode={isEditMode}
               currentRow={singleEntity}
               initialData={singleEntity}
               parentGlGroup={parentGlGroup}
               formType={formType}
            />
         )}

         {formType === 'Item' && (
            <ItemMasterForm isOpen={isOpen} onClose={handleClose} isEditMode={isEditMode} currentRow={singleEntity} />
         )}

         {formType === 'Account' && (
            <AddEditFormForAccount
               isOpen={isOpen}
               onClose={handleClose}
               isEditMode={isEditMode}
               currentRow={singleEntity}
               initialData={singleEntity}
               formType={formType}
            />
         )}

         {formType === 'daybook' && (
            <DaybookForm isOpen={isOpen} onClose={handleClose} isEditMode={isEditMode} currentRow={singleEntity} />
         )}

         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title={formType}
         />
      </>
   );
};

export default ViewSingleCashBankData;
